import React from "react";
import "./input-with-unit-select.css";

interface InputWithUnitSelectProps<T extends string> {
  id: string;
  name: string;
  value: string;
  unit: T;
  unitOptions: Array<{ value: T; label: string }>;
  step?: string;
  min?: string;
  onValueChange: (value: string) => void;
  onUnitChange: (unit: T) => void;
}

const InputWithUnitSelect = <T extends string>({
  id,
  name,
  value,
  unit,
  unitOptions,
  step = "0.1",
  min = "0",
  onValueChange,
  onUnitChange,
}: InputWithUnitSelectProps<T>) => (
  <div className="input-unit-combo">
    <input
      type="number"
      id={id}
      name={name}
      className="input-unit-combo__value pih-numeric-input"
      step={step}
      min={min}
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
    />
    <div className="input-unit-combo__divider" aria-hidden="true" />
    <select
      className="input-unit-combo__unit"
      value={unit}
      aria-label={`${name} unit`}
      onChange={(event) => onUnitChange(event.target.value as T)}
    >
      {unitOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default InputWithUnitSelect;
